export enum BuildingPermitStage {
  Completed = 'Completed',
  Issued = 'Issued',
  Applied = 'Applied',
  Cancelled = 'Cancelled',
}
